// src/pages/ProfilePage.js – Cinematic enhanced
import React from 'react';
import { useAuth } from '../context/AuthContext';
import Achievements from '../components/Achievements';
import useViewport from '../hooks/useViewport';

export default function ProfilePage() {
  const { user } = useAuth();
  const { isMobile } = useViewport();
  if (!user) return null;

  const xpPct = Math.min(((user.xp - (user.level-1)*500) / 500) * 100, 100);
  const STATS = [
    { val:user.level,                          label:'LEVEL',    color:'#00f5ff' },
    { val:user.xp,                             label:'TOTAL XP', color:'#7c3aed' },
    { val:user.coins,                          label:'COINS',    color:'#ffd700' },
    { val:user.streak||0,                      label:'STREAK',   color:'#39ff14' },
    { val:(user.completedMissions||[]).length, label:'MISSIONS', color:'#ff6432' },
    { val:(user.badges||[]).length,            label:'BADGES',   color:'#bf5fff' },
  ];

  return (
    <div className="page-shell">
      {/* Hero card */}
      <div className="animate-fade-in" style={{
        background:'linear-gradient(135deg,rgba(0,245,255,0.06),rgba(124,58,237,0.06))',
        border:'1px solid rgba(0,245,255,0.16)', borderRadius:'14px', padding:isMobile ? '18px 16px' : '24px 28px',
        display:'flex', alignItems:'center', gap:'26px', marginBottom:'22px', flexWrap:isMobile ? 'wrap' : 'nowrap',
        backdropFilter:'blur(12px)', WebkitBackdropFilter:'blur(12px)',
        boxShadow:'0 0 40px rgba(0,245,255,0.05)',
      }}>
        <div style={{
          width:isMobile ? '64px' : '76px', height:isMobile ? '64px' : '76px', borderRadius:'50%', flexShrink:0,
          background:'linear-gradient(135deg,#00f5ff,#7c3aed)',
          display:'flex', alignItems:'center', justifyContent:'center',
          fontSize:isMobile ? '32px' : '40px', border:'2px solid rgba(0,245,255,0.35)',
          boxShadow:'0 0 24px rgba(0,245,255,0.25)',
        }}>
          {user.avatar || '🧑‍💻'}
        </div>
        <div style={{ flex:1 }}>
          <div style={{ fontFamily:'var(--font-game)', fontSize:isMobile ? '18px' : '22px', fontWeight:700, color:'#fff', marginBottom:'3px',
                        textShadow:'0 0 14px rgba(0,245,255,0.2)' }}>
            {user.username}
          </div>
          <div style={{ color:'rgba(255,255,255,0.35)', fontSize:'15px', marginBottom:'12px' }}>{user.email}</div>
          <div style={{ display:'flex', alignItems:'center', gap:'9px', maxWidth:isMobile ? '100%' : '280px' }}>
            <span style={{ fontFamily:'var(--font-game)', fontSize:'15px', color:'#00f5ff', letterSpacing:'1px', flexShrink:0 }}>LVL {user.level}</span>
            <div className="xp-bar" style={{ flex:1, height:'7px' }}>
              <div className="xp-fill" style={{ width:`${xpPct}%` }} />
            </div>
            <span style={{ fontFamily:'var(--font-game)', fontSize:'15px', color:'rgba(255,255,255,0.3)', flexShrink:0 }}>
              {user.xp}/{user.level*500}
            </span>
          </div>
        </div>
        {user.role === 'admin' && (
          <div style={{ background:'rgba(255,68,68,0.1)', border:'1px solid rgba(255,68,68,0.3)',
                        borderRadius:'6px', padding:'5px 12px', fontFamily:'var(--font-game)',
                        fontSize:'15px', color:'#ff8888', letterSpacing:'2px' }}>ADMIN</div>
        )}
      </div>

      {/* Stats */}
      <div className="animate-fade-in" style={{ marginBottom:'24px' }}>
        <div className="section-title">STATS</div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(120px,1fr))', gap:'11px' }}>
          {STATS.map(s => (
            <div key={s.label} className="stat-card">
              <div style={{ fontFamily:'var(--font-game)', fontSize:'24px', fontWeight:700, color:s.color,
                            textShadow:`0 0 10px ${s.color}66` }}>{s.val}</div>
              <div className="stat-lbl">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Inventory */}
      {(user.inventory || []).length > 0 && (
        <div className="animate-fade-in" style={{ marginBottom:'24px' }}>
          <div className="section-title">INVENTORY</div>
          <div style={{ display:'flex', gap:'9px', flexWrap:'wrap' }}>
            {user.inventory.map((item, i) => (
              <div key={i} style={{ background:'rgba(57,255,20,0.06)', border:'1px solid rgba(57,255,20,0.22)',
                                    borderRadius:'7px', padding:'7px 13px', display:'flex', alignItems:'center',
                                    gap:'7px', fontSize:'15px', fontWeight:600, color:'#39ff14',
                                    boxShadow:'0 0 12px rgba(57,255,20,0.08)' }}>
                ✓ {item.name}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Achievements */}
      <div className="animate-fade-in">
        <div className="section-title">ACHIEVEMENTS</div>
        <Achievements />
      </div>
    </div>
  );
}
